<template>
  <div class="account-pages my-5 pt-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="text-center mb-5">
            <div v-if="!showError">
              <h1 class="display-2 fw-medium">
                <b-spinner></b-spinner>
              </h1>
              <h4 v-html="$t('lwa.redirect.message', {s: counter})"></h4>
              <div class="mt-5 text-center">
              </div>
            </div>

            <div class="text-center mb-5" v-else>
              <div class="mb-4 avatar-md mx-auto">
                <div class="avatar-title rounded-circle bg-light">
                  <i class="bx bx-error-circle h1 mb-0 text-danger"></i>
                </div>
              </div>
              <h4>{{ $t('lwa.redirect.link_invalid') }}</h4>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "LwaRedirect",
  page() {
    return {
      title: this.$t('lwa.redirect.title'),
      meta: [
        {
          name: "description",
          content: this.$t('common.app_title')
        }
      ]
    }
  },
  data() {
    return {
      counter: 3,
      interval: null,
      showError: false
    }
  },
  methods: {
    redirect(url) {
      clearInterval(this.interval)
      window.location.href = url
    },
    handleError() {
      this.showError = true
      setTimeout(() => {
        window.close();
      }, 5000)
    }
  },
  mounted() {
    const query = this.$route.query
    if (query.currentLwaUri && query.state) {
      this.interval = setInterval(() => {
        this.counter -= 1
        if (this.counter <= 1) {
          clearInterval(this.interval)
          const url = `${query.currentLwaUri}&state=${query.state}${query.version ? '&version=' + query.version : ''}`
          this.redirect(url)
        }
      }, 1000)
    } else {
      this.handleError()
    }


  }
}
</script>

